import SiafLiteApiRepository from "../../external/siafLiteApi";
import { SiafLiteApiStream } from "../../external";
import store from "../../config/store";
class PedidosService {
  constructor() {
    this.urlBase = "/faturamento/pedidos";
    this.urlBaseEvent = `/event${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}${this.urlBase}`;
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  cancelar(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/cancelar`
    ).get();
  }

  getRelatorioResumido(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/resumido`
    ).patch(body);
  }

  relatorioResumido(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/resumido`
    ).path(body);
  }

  getRelatorioTotais() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/totais`
    ).get();
  }

  pdf(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/pdf`).post(body);
  }

  pdfSecundario(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/pdf-secundario`
    ).post(body);
  }
}

export default PedidosService;
